import React from "react";
import { Link } from "react-router-dom";

const menuItems = [
  {
    id: 1,
    title: "Analytics",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clip-path="url(#clip0_1579_838)">
          <path
            d="M11.5093 6.04389C11.7143 6.15354 11.9283 6.24389 12.1487 6.31413L10.0906 9.03664L7.28602 4.85903L6.87483 4.24653L6.45824 4.85538L3.77368 8.77897L2.99786 8.09222L2.61979 7.75756L2.28884 8.13888L1.67551 8.84554L1.38867 9.17603V3.11106C1.38867 3.00792 1.42964 2.909 1.50257 2.83607C1.57551 2.76314 1.67442 2.72217 1.77756 2.72217H9.49819C9.50117 3.04745 9.54585 3.3718 9.63171 3.68718C9.76781 4.18711 10.0045 4.65398 10.3274 5.05922C10.6502 5.46446 11.0524 5.79952 11.5093 6.04389ZM4.46597 11.2331L6.86719 7.71838L9.61127 11.8075L10.0021 12.3898L10.4252 11.8305L14.3452 6.64825L14.6109 6.29702V12.8888C14.6109 12.992 14.5699 13.0909 14.497 13.1638C14.4241 13.2368 14.3251 13.2777 14.222 13.2777H1.77756C1.67442 13.2777 1.57551 13.2368 1.50258 13.1638C1.42964 13.0909 1.38867 12.992 1.38867 12.8888V9.25164L1.72093 9.54698L3.72093 11.3248L4.14551 11.7022L4.46597 11.2331Z"
            fill="#646464"
            stroke="#646464"
          />
          <path
            d="M15.0558 2.66656C15.0558 3.61772 14.2847 4.38878 13.3336 4.38878C12.3824 4.38878 11.6113 3.61772 11.6113 2.66656C11.6113 1.7154 12.3824 0.944336 13.3336 0.944336C14.2847 0.944336 15.0558 1.7154 15.0558 2.66656Z"
            stroke="#646464"
          />
        </g>
        <defs>
          <clipPath id="clip0_1579_838">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clip-path="url(#clip0_1579_2122)">
          <path
            d="M11.5093 6.04438C11.7143 6.15403 11.9283 6.24438 12.1487 6.31462L10.0906 9.03713L7.28602 4.85952L6.87483 4.24702L6.45824 4.85587L3.77368 8.77946L2.99786 8.09271L2.61979 7.75805L2.28884 8.13936L1.67551 8.84603L1.38867 9.17652V3.11155C1.38867 3.00841 1.42964 2.90949 1.50257 2.83656C1.57551 2.76363 1.67442 2.72266 1.77756 2.72266H9.49819C9.50117 3.04794 9.54585 3.37229 9.63171 3.68767C9.76781 4.1876 10.0045 4.65447 10.3274 5.05971C10.6502 5.46495 11.0524 5.80001 11.5093 6.04438ZM4.46597 11.2336L6.86719 7.71887L9.61127 11.8079L10.0021 12.3903L10.4252 11.831L14.3452 6.64874L14.6109 6.29751V12.8893C14.6109 12.9925 14.5699 13.0914 14.497 13.1643C14.4241 13.2372 14.3251 13.2782 14.222 13.2782H1.77756C1.67442 13.2782 1.57551 13.2372 1.50258 13.1643C1.42964 13.0914 1.38867 12.9925 1.38867 12.8893V9.25213L1.72093 9.54747L3.72093 11.3253L4.14551 11.7027L4.46597 11.2336Z"
            stroke="white"
          />
          <path
            d="M15.0558 2.66656C15.0558 3.61772 14.2847 4.38878 13.3336 4.38878C12.3824 4.38878 11.6113 3.61772 11.6113 2.66656C11.6113 1.7154 12.3824 0.944336 13.3336 0.944336C14.2847 0.944336 15.0558 1.7154 15.0558 2.66656Z"
            stroke="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1579_2122">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: "analytics",
  },
  {
    id: 2,
    title: "Users",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00065 6.66683C9.47341 6.66683 10.6673 5.47292 10.6673 4.00016C10.6673 2.5274 9.47341 1.3335 8.00065 1.3335C6.52789 1.3335 5.33398 2.5274 5.33398 4.00016C5.33398 5.47292 6.52789 6.66683 8.00065 6.66683Z"
          fill="#161616"
          fill-opacity="0.6"
        />
        <path
          d="M13.3327 11.6665C13.3327 13.3232 13.3327 14.6665 7.99935 14.6665C2.66602 14.6665 2.66602 13.3232 2.66602 11.6665C2.66602 10.0098 5.05402 8.6665 7.99935 8.6665C10.9447 8.6665 13.3327 10.0098 13.3327 11.6665Z"
          fill="#161616"
          fill-opacity="0.6"
        />
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00016 7.16683C9.74906 7.16683 11.1668 5.74906 11.1668 4.00016C11.1668 2.25126 9.74906 0.833496 8.00016 0.833496C6.25126 0.833496 4.8335 2.25126 4.8335 4.00016C4.8335 5.74906 6.25126 7.16683 8.00016 7.16683Z"
          stroke="white"
        />
        <path
          d="M7.99984 15.1665C9.35036 15.1665 10.387 15.0818 11.1824 14.9208C11.9755 14.7602 12.5626 14.5172 12.9822 14.1755C13.8349 13.4811 13.834 12.509 13.8332 11.7345C13.8332 11.7116 13.8332 11.689 13.8332 11.6665C13.8332 10.5773 13.0534 9.69296 12.0161 9.10947C10.9631 8.51715 9.54213 8.1665 7.99984 8.1665C6.45755 8.1665 5.03653 8.51715 3.98354 9.10947C2.94624 9.69296 2.1665 10.5773 2.1665 11.6665C2.1665 11.689 2.16648 11.7116 2.16646 11.7345C2.16571 12.509 2.16476 13.4811 3.01744 14.1755C3.43708 14.5172 4.02414 14.7602 4.8173 14.9208C5.61267 15.0818 6.64932 15.1665 7.99984 15.1665Z"
          stroke="white"
        />
      </svg>
    ),
    link: "users",
  },
  {
    id: 3,
    title: "Trades",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12.6665 8.66683C12.8932 8.66683 13.1132 8.6935 13.3332 8.72683V5.3335L9.33317 1.3335H3.99984C3.25984 1.3335 2.6665 1.92683 2.6665 2.66683V13.3335C2.6665 14.0735 3.25984 14.6668 3.99984 14.6668H9.2065C8.8665 14.0802 8.6665 13.4002 8.6665 12.6668C8.6665 10.4602 10.4598 8.66683 12.6665 8.66683ZM8.6665 2.3335L12.3332 6.00016H8.6665V2.3335ZM13.3332 13.0002V12.0002H10.6665V10.6668H13.3332V9.66683L15.3332 11.3335L13.3332 13.0002ZM11.9998 13.3335H14.6665V14.6668H11.9998V15.6668L9.99984 14.0002L11.9998 12.3335V13.3335Z"
          fill="#161616"
          fill-opacity="0.6"
        />
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12.8334 13.8334V14.0676L13.1144 13.8334H14.1667V14.1667H12.0001H11.5001V14.5992L10.7811 14L11.5001 13.4009V13.8334H12.0001H12.8334ZM14.5524 11.3334L13.8334 11.9325V11.5H13.3334H12.5001V11.2659L12.2191 11.5H11.1667V11.1667H13.3334H13.8334V10.7342L14.5524 11.3334ZM12.8334 8.17067C12.7786 8.16812 12.723 8.16671 12.6667 8.16671C10.1839 8.16671 8.16675 10.1839 8.16675 12.6667C8.16675 13.1954 8.25919 13.6996 8.42586 14.1667H4.00008C3.53622 14.1667 3.16675 13.7972 3.16675 13.3334V2.66671C3.16675 2.20285 3.53622 1.83337 4.00008 1.83337H8.16675V2.33337V6.00004V6.50004H8.66675H12.3334H12.8334V8.17067ZM12.8334 5.54048V5.79293L12.687 5.64649L9.0203 1.97982L8.87385 1.83337H9.12631L12.8334 5.54048Z"
          stroke="white"
        />
      </svg>
    ),
    link: "trades",
  },
  {
    id: 4,
    title: "Receipts",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2 3.75C2 2.784 2.784 2 3.75 2H9.25C10.216 2 11 2.784 11 3.75V10H14V11.5C14 12.163 13.7366 12.7989 13.2678 13.2678C12.7989 13.7366 12.163 14 11.5 14H4.5C3.83696 14 3.20107 13.7366 2.73223 13.2678C2.26339 12.7989 2 12.163 2 11.5V3.75ZM11 13H11.5C11.8978 13 12.2794 12.842 12.5607 12.5607C12.842 12.2794 13 11.8978 13 11.5V11H11V13ZM4.5 5.5C4.5 5.63261 4.55268 5.75979 4.64645 5.85355C4.74021 5.94732 4.86739 6 5 6H8C8.13261 6 8.25979 5.94732 8.35355 5.85355C8.44732 5.75979 8.5 5.63261 8.5 5.5C8.5 5.36739 8.44732 5.24021 8.35355 5.14645C8.25979 5.05268 8.13261 5 8 5H5C4.86739 5 4.74021 5.05268 4.64645 5.14645C4.55268 5.24021 4.5 5.36739 4.5 5.5ZM5 7.5C4.86739 7.5 4.74021 7.55268 4.64645 7.64645C4.55268 7.74021 4.5 7.86739 4.5 8C4.5 8.13261 4.55268 8.25979 4.64645 8.35355C4.74021 8.44732 4.86739 8.5 5 8.5H8C8.13261 8.5 8.25979 8.44732 8.35355 8.35355C8.44732 8.25979 8.5 8.13261 8.5 8C8.5 7.86739 8.44732 7.74021 8.35355 7.64645C8.25979 7.55268 8.13261 7.5 8 7.5H5ZM4.5 10.5C4.5 10.6326 4.55268 10.7598 4.64645 10.8536C4.74021 10.9473 4.86739 11 5 11H6.5C6.63261 11 6.75979 10.9473 6.85355 10.8536C6.94732 10.7598 7 10.6326 7 10.5C7 10.3674 6.94732 10.2402 6.85355 10.1464C6.75979 10.0527 6.63261 10 6.5 10H5C4.86739 10 4.74021 10.0527 4.64645 10.1464C4.55268 10.2402 4.5 10.3674 4.5 10.5Z"
          fill="#161616"
          fill-opacity="0.6"
        />
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M10.5 10V10.5V11V13V13.5H4.5C3.96957 13.5 3.46086 13.2893 3.08579 12.9142C2.71071 12.5391 2.5 12.0304 2.5 11.5V3.75C2.5 3.06014 3.06014 2.5 3.75 2.5H9.25C9.93986 2.5 10.5 3.06014 10.5 3.75V10ZM4 5.5C4 5.76522 4.10536 6.01957 4.29289 6.20711C4.48043 6.39464 4.73478 6.5 5 6.5H8C8.26522 6.5 8.51957 6.39464 8.70711 6.20711C8.89464 6.01957 9 5.76522 9 5.5C9 5.23478 8.89464 4.98043 8.70711 4.79289C8.51957 4.60536 8.26522 4.5 8 4.5H5C4.73478 4.5 4.48043 4.60536 4.29289 4.79289C4.10536 4.98043 4 5.23478 4 5.5ZM5 7C4.73478 7 4.48043 7.10536 4.29289 7.29289C4.10536 7.48043 4 7.73478 4 8C4 8.26522 4.10536 8.51957 4.29289 8.70711C4.48043 8.89464 4.73478 9 5 9H8C8.26522 9 8.51957 8.89464 8.70711 8.70711C8.89464 8.51957 9 8.26522 9 8C9 7.73478 8.89464 7.48043 8.70711 7.29289C8.51957 7.10536 8.26522 7 8 7H5ZM4 10.5C4 10.7652 4.10536 11.0196 4.29289 11.2071C4.48043 11.3946 4.73478 11.5 5 11.5H6.5C6.76522 11.5 7.01957 11.3946 7.20711 11.2071C7.39464 11.0196 7.5 10.7652 7.5 10.5C7.5 10.2348 7.39464 9.98043 7.20711 9.79289C7.01957 9.60536 6.76522 9.5 6.5 9.5H5C4.73478 9.5 4.48043 9.60536 4.29289 9.79289C4.10536 9.98043 4 10.2348 4 10.5Z"
          stroke="white"
        />
      </svg>
    ),
    link: "receipts",
  },
  {
    id: 5,
    title: "Referrals",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M7.9999 1.59998C7.15121 1.59998 6.33728 1.93712 5.73716 2.53723C5.13704 3.13735 4.7999 3.95128 4.7999 4.79998C4.7999 5.64867 5.13704 6.4626 5.73716 7.06272C6.33728 7.66283 7.15121 7.99998 7.9999 7.99998C8.8486 7.99998 9.66253 7.66283 10.2626 7.06272C10.8628 6.4626 11.1999 5.64867 11.1999 4.79998C11.1999 3.95128 10.8628 3.13735 10.2626 2.53723C9.66253 1.93712 8.8486 1.59998 7.9999 1.59998ZM4.0071 8.79998C3.79641 8.79913 3.58763 8.83989 3.39272 8.91991C3.19782 8.99993 3.02063 9.11764 2.87131 9.26629C2.72199 9.41494 2.60349 9.5916 2.5226 9.78614C2.4417 9.98068 2.40001 10.1893 2.3999 10.4C2.3999 11.7528 3.0663 12.7728 4.1079 13.4376C4.9463 13.972 6.0239 14.276 7.1999 14.368V11.2C7.1999 10.7756 7.36847 10.3687 7.66853 10.0686C7.96859 9.76855 8.37556 9.59998 8.7999 9.59998H13.3855C13.2451 9.35675 13.0431 9.15477 12.7999 9.01434C12.5567 8.87392 12.2808 8.79998 11.9999 8.79998H4.0071ZM15.1999 11.6V14C15.1999 14.3182 15.0735 14.6235 14.8484 14.8485C14.6234 15.0735 14.3182 15.2 13.9999 15.2H9.1999C8.88164 15.2 8.57642 15.0735 8.35137 14.8485C8.12633 14.6235 7.9999 14.3182 7.9999 14V11.6C7.9999 11.2817 8.12633 10.9765 8.35137 10.7514C8.57642 10.5264 8.88164 10.4 9.1999 10.4H13.9999C14.3182 10.4 14.6234 10.5264 14.8484 10.7514C15.0735 10.9765 15.1999 11.2817 15.1999 11.6ZM14.3999 14V13.2C14.0816 13.2 13.7764 13.3264 13.5514 13.5514C13.3263 13.7765 13.1999 14.0817 13.1999 14.4H13.9999C13.9999 14.2939 14.042 14.1921 14.1171 14.1171C14.1921 14.0421 14.2938 14 14.3999 14ZM14.3999 11.6C14.2938 11.6 14.1921 11.5578 14.1171 11.4828C14.042 11.4078 13.9999 11.3061 13.9999 11.2H13.1999C13.1999 11.5182 13.3263 11.8235 13.5514 12.0485C13.7764 12.2735 14.0816 12.4 14.3999 12.4V11.6ZM9.1999 11.2C9.1999 11.3061 9.15776 11.4078 9.08275 11.4828C9.00773 11.5578 8.90599 11.6 8.7999 11.6V12.4C9.11816 12.4 9.42339 12.2735 9.64843 12.0485C9.87347 11.8235 9.9999 11.5182 9.9999 11.2H9.1999ZM8.7999 14C8.90599 14 9.00773 14.0421 9.08275 14.1171C9.15776 14.1921 9.1999 14.2939 9.1999 14.4H9.9999C9.9999 14.0817 9.87347 13.7765 9.64843 13.5514C9.42339 13.3264 9.11816 13.2 8.7999 13.2V14ZM11.5999 11.6C11.2816 11.6 10.9764 11.7264 10.7514 11.9514C10.5263 12.1765 10.3999 12.4817 10.3999 12.8C10.3999 13.1182 10.5263 13.4235 10.7514 13.6485C10.9764 13.8735 11.2816 14 11.5999 14C11.9182 14 12.2234 13.8735 12.4484 13.6485C12.6735 13.4235 12.7999 13.1182 12.7999 12.8C12.7999 12.4817 12.6735 12.1765 12.4484 11.9514C12.2234 11.7264 11.9182 11.6 11.5999 11.6Z"
          fill="#161616"
          fill-opacity="0.6"
        />
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <mask id="path-1-inside-1_1599_2189" fill="white">
          <path d="M8.00039 1.6001C7.1517 1.6001 6.33777 1.93724 5.73765 2.53736C5.13753 3.13747 4.80039 3.9514 4.80039 4.8001C4.80039 5.64879 5.13753 6.46272 5.73765 7.06284C6.33777 7.66296 7.1517 8.0001 8.00039 8.0001C8.84908 8.0001 9.66302 7.66296 10.2631 7.06284C10.8632 6.46272 11.2004 5.64879 11.2004 4.8001C11.2004 3.9514 10.8632 3.13747 10.2631 2.53736C9.66302 1.93724 8.84908 1.6001 8.00039 1.6001ZM4.00759 8.8001C3.7969 8.79926 3.58812 8.84001 3.39321 8.92003C3.19831 9.00005 3.02111 9.11776 2.8718 9.26641C2.72248 9.41506 2.60398 9.59172 2.52308 9.78626C2.44219 9.98081 2.40049 10.1894 2.40039 10.4001C2.40039 11.7529 3.06679 12.7729 4.10839 13.4377C4.94679 13.9721 6.02439 14.2761 7.20039 14.3681V11.2001C7.20039 10.7758 7.36896 10.3688 7.66902 10.0687C7.96908 9.76867 8.37604 9.6001 8.80039 9.6001H13.386C13.2456 9.35687 13.0436 9.1549 12.8004 9.01447C12.5571 8.87404 12.2812 8.80011 12.0004 8.8001H4.00759ZM15.2004 11.6001V14.0001C15.2004 14.3184 15.074 14.6236 14.8489 14.8486C14.6239 15.0737 14.3187 15.2001 14.0004 15.2001H9.20039C8.88213 15.2001 8.57691 15.0737 8.35186 14.8486C8.12682 14.6236 8.00039 14.3184 8.00039 14.0001V11.6001C8.00039 11.2818 8.12682 10.9766 8.35186 10.7516C8.57691 10.5265 8.88213 10.4001 9.20039 10.4001H14.0004C14.3187 10.4001 14.6239 10.5265 14.8489 10.7516C15.074 10.9766 15.2004 11.2818 15.2004 11.6001ZM14.4004 14.0001V13.2001C14.0821 13.2001 13.7769 13.3265 13.5519 13.5516C13.3268 13.7766 13.2004 14.0818 13.2004 14.4001H14.0004C14.0004 14.294 14.0425 14.1923 14.1175 14.1173C14.1926 14.0422 14.2943 14.0001 14.4004 14.0001ZM14.4004 11.6001C14.2943 11.6001 14.1926 11.558 14.1175 11.4829C14.0425 11.4079 14.0004 11.3062 14.0004 11.2001H13.2004C13.2004 11.5184 13.3268 11.8236 13.5519 12.0486C13.7769 12.2737 14.0821 12.4001 14.4004 12.4001V11.6001ZM9.20039 11.2001C9.20039 11.3062 9.15825 11.4079 9.08323 11.4829C9.00822 11.558 8.90648 11.6001 8.80039 11.6001V12.4001C9.11865 12.4001 9.42388 12.2737 9.64892 12.0486C9.87396 11.8236 10.0004 11.5184 10.0004 11.2001H9.20039ZM8.80039 14.0001C8.90648 14.0001 9.00822 14.0422 9.08323 14.1173C9.15825 14.1923 9.20039 14.294 9.20039 14.4001H10.0004C10.0004 14.0818 9.87396 13.7766 9.64892 13.5516C9.42388 13.3265 9.11865 13.2001 8.80039 13.2001V14.0001ZM11.6004 11.6001C11.2821 11.6001 10.9769 11.7265 10.7519 11.9516C10.5268 12.1766 10.4004 12.4818 10.4004 12.8001C10.4004 13.1184 10.5268 13.4236 10.7519 13.6486C10.9769 13.8737 11.2821 14.0001 11.6004 14.0001C11.9187 14.0001 12.2239 13.8737 12.4489 13.6486C12.674 13.4236 12.8004 13.1184 12.8004 12.8001C12.8004 12.4818 12.674 12.1766 12.4489 11.9516C12.2239 11.7265 11.9187 11.6001 11.6004 11.6001Z" />
        </mask>
        <path
          d="M8.00039 1.6001V0.600098V1.6001ZM4.80039 4.8001H3.80039H4.80039ZM8.00039 8.0001V9.0001V8.0001ZM11.2004 4.8001H12.2004H11.2004ZM4.00759 8.8001L4.00359 9.8001H4.00759V8.8001ZM2.40039 10.4001L1.40039 10.3996V10.4001H2.40039ZM4.10839 13.4377L3.57038 14.2806L3.57089 14.281L4.10839 13.4377ZM7.20039 14.3681L7.1224 15.3651L8.20039 15.4494V14.3681H7.20039ZM8.80039 9.6001V10.6001V9.6001ZM13.386 9.6001V10.6001H15.118L14.252 9.1001L13.386 9.6001ZM12.0004 8.8001L12.0004 7.8001H12.0004V8.8001ZM8.00039 14.0001H7.00039H8.00039ZM9.20039 10.4001V9.4001V10.4001ZM14.0004 10.4001V9.4001V10.4001ZM14.4004 14.0001V15.0001H15.4004V14.0001H14.4004ZM14.4004 13.2001H15.4004V12.2001H14.4004V13.2001ZM13.2004 14.4001H12.2004V15.4001H13.2004V14.4001ZM14.0004 14.4001V15.4001H15.0004V14.4001H14.0004ZM14.4004 11.6001H15.4004V10.6001H14.4004V11.6001ZM14.0004 11.2001H15.0004V10.2001H14.0004V11.2001ZM13.2004 11.2001V10.2001H12.2004V11.2001H13.2004ZM14.4004 12.4001V13.4001H15.4004V12.4001H14.4004ZM9.20039 11.2001V10.2001H8.20039V11.2001H9.20039ZM8.80039 11.6001V10.6001H7.80039V11.6001H8.80039ZM8.80039 12.4001H7.80039V13.4001H8.80039V12.4001ZM10.0004 11.2001H11.0004V10.2001H10.0004V11.2001ZM8.80039 14.0001H7.80039V15.0001H8.80039V14.0001ZM9.20039 14.4001H8.20039V15.4001H9.20039V14.4001ZM10.0004 14.4001V15.4001H11.0004V14.4001H10.0004ZM8.80039 13.2001V12.2001H7.80039V13.2001H8.80039ZM11.6004 11.6001V10.6001V11.6001ZM10.4004 12.8001H9.40039H10.4004ZM12.8004 12.8001H13.8004H12.8004ZM8.00039 0.600098C6.88648 0.600098 5.81819 1.0426 5.03054 1.83025L6.44476 3.24446C6.85734 2.83188 7.41691 2.6001 8.00039 2.6001V0.600098ZM5.03054 1.83025C4.24289 2.6179 3.80039 3.68619 3.80039 4.8001H5.80039C5.80039 4.21662 6.03218 3.65704 6.44476 3.24446L5.03054 1.83025ZM3.80039 4.8001C3.80039 5.91401 4.24289 6.98229 5.03054 7.76995L6.44476 6.35573C6.03218 5.94315 5.80039 5.38357 5.80039 4.8001H3.80039ZM5.03054 7.76995C5.81819 8.5576 6.88648 9.0001 8.00039 9.0001V7.0001C7.41691 7.0001 6.85734 6.76831 6.44476 6.35573L5.03054 7.76995ZM8.00039 9.0001C9.1143 9.0001 10.1826 8.5576 10.9702 7.76995L9.55603 6.35573C9.14345 6.76831 8.58387 7.0001 8.00039 7.0001V9.0001ZM10.9702 7.76995C11.7579 6.98229 12.2004 5.91401 12.2004 4.8001H10.2004C10.2004 5.38357 9.96861 5.94315 9.55603 6.35573L10.9702 7.76995ZM12.2004 4.8001C12.2004 3.68619 11.7579 2.6179 10.9702 1.83025L9.55603 3.24446C9.96861 3.65704 10.2004 4.21662 10.2004 4.8001H12.2004ZM10.9702 1.83025C10.1826 1.0426 9.1143 0.600098 8.00039 0.600098V2.6001C8.58387 2.6001 9.14345 2.83188 9.55603 3.24446L10.9702 1.83025ZM4.01159 7.80011C3.66928 7.79874 3.33007 7.86496 3.01341 7.99496L3.77301 9.8451C3.84616 9.81507 3.92452 9.79977 4.00359 9.80009L4.01159 7.80011ZM3.01341 7.99496C2.69675 8.12497 2.40887 8.31621 2.16628 8.55772L3.57732 9.9751C3.63336 9.91931 3.69986 9.87514 3.77301 9.8451L3.01341 7.99496ZM2.16628 8.55772C1.92369 8.79922 1.73116 9.08624 1.59973 9.40231L3.44644 10.1702C3.4768 10.0972 3.52127 10.0309 3.57732 9.9751L2.16628 8.55772ZM1.59973 9.40231C1.4683 9.71839 1.40056 10.0573 1.40039 10.3996L3.40039 10.4006C3.40043 10.3215 3.41608 10.2432 3.44644 10.1702L1.59973 9.40231ZM1.40039 10.4001C1.40039 12.1359 2.27789 13.4557 3.57038 14.2806L4.6464 12.5948C3.85569 12.0901 3.40039 11.3699 3.40039 10.4001H1.40039ZM3.57089 14.281C4.5852 14.9275 5.83416 15.2643 7.1224 15.3651L7.27838 13.3711C6.21462 13.2879 5.30838 13.0167 4.64589 12.5944L3.57089 14.281ZM8.20039 14.3681V11.2001H6.20039V14.3681H8.20039ZM8.20039 11.2001C8.20039 11.041 8.2636 10.8884 8.37613 10.7758L6.96191 9.36162C6.47432 9.84921 6.20039 10.5105 6.20039 11.2001H8.20039ZM8.37613 10.7758C8.48865 10.6633 8.64126 10.6001 8.80039 10.6001V8.6001C8.11083 8.6001 7.44951 8.87403 6.96191 9.36162L8.37613 10.7758ZM8.80039 10.6001H13.386V8.6001H8.80039V10.6001ZM14.252 9.1001C14.0238 8.70486 13.6956 8.37665 13.3004 8.14845L12.3004 9.88049C12.3916 9.93315 12.4673 10.0089 12.52 10.1001L14.252 9.1001ZM13.3004 8.14845C12.9051 7.92025 12.4568 7.80011 12.0004 7.8001L12.0004 9.8001C12.1057 9.8001 12.2091 9.82783 12.3004 9.88049L13.3004 8.14845ZM12.0004 7.8001H4.00759V9.8001H12.0004V7.8001ZM14.2004 11.6001V14.0001H16.2004V11.6001H14.2004ZM14.2004 14.0001C14.2004 14.0531 14.1793 14.104 14.1418 14.1415L15.556 15.5557C15.9686 15.1432 16.2004 14.5836 16.2004 14.0001H14.2004ZM14.1418 14.1415C14.1043 14.179 14.0534 14.2001 14.0004 14.2001V16.2001C14.5839 16.2001 15.1434 15.9683 15.556 15.5557L14.1418 14.1415ZM14.0004 14.2001H9.20039V16.2001H14.0004V14.2001ZM9.20039 14.2001C9.14735 14.2001 9.09648 14.179 9.05897 14.1415L7.64476 15.5557C8.05733 15.9683 8.61691 16.2001 9.20039 16.2001V14.2001ZM9.05897 14.1415C9.02146 14.104 9.00039 14.0531 9.00039 14.0001H7.00039C7.00039 14.5836 7.23218 15.1432 7.64476 15.5557L9.05897 14.1415ZM9.00039 14.0001V11.6001H7.00039V14.0001H9.00039ZM9.00039 11.6001C9.00039 11.5471 9.02146 11.4962 9.05897 11.4587L7.64476 10.0445C7.23218 10.457 7.00039 11.0166 7.00039 11.6001H9.00039ZM9.05897 11.4587C9.09648 11.4212 9.14735 11.4001 9.20039 11.4001V9.4001C8.61691 9.4001 8.05734 9.63188 7.64476 10.0445L9.05897 11.4587ZM9.20039 11.4001H14.0004V9.4001H9.20039V11.4001ZM14.0004 11.4001C14.0534 11.4001 14.1043 11.4212 14.1418 11.4587L15.556 10.0445C15.1434 9.63188 14.5839 9.4001 14.0004 9.4001V11.4001ZM14.1418 11.4587C14.1793 11.4962 14.2004 11.5471 14.2004 11.6001H16.2004C16.2004 11.0166 15.9686 10.457 15.556 10.0445L14.1418 11.4587ZM15.4004 14.0001V13.2001H13.4004V14.0001H15.4004ZM14.4004 12.2001C13.8169 12.2001 13.2573 12.4319 12.8448 12.8445L14.259 14.2587C14.2965 14.2212 14.3473 14.2001 14.4004 14.2001V12.2001ZM12.8448 12.8445C12.4322 13.257 12.2004 13.8166 12.2004 14.4001H14.2004C14.2004 14.3471 14.2215 14.2962 14.259 14.2587L12.8448 12.8445ZM13.2004 15.4001H14.0004V13.4001H13.2004V15.4001ZM15.0004 14.4001C15.0004 14.5592 14.9372 14.7118 14.8247 14.8244L13.4104 13.4101C13.1479 13.6727 13.0004 14.0288 13.0004 14.4001H15.0004ZM14.8247 14.8244C14.7121 14.9369 14.5595 15.0001 14.4004 15.0001V13.0001C14.0291 13.0001 13.673 13.1476 13.4104 13.4101L14.8247 14.8244ZM14.4004 10.6001C14.5595 10.6001 14.7121 10.6633 14.8247 10.7758L13.4104 12.19C13.673 12.4526 14.0291 12.6001 14.4004 12.6001V10.6001ZM14.8247 10.7758C14.9372 10.8884 15.0004 11.041 15.0004 11.2001H13.0004C13.0004 11.5714 13.1479 11.9275 13.4104 12.19L14.8247 10.7758ZM14.0004 10.2001H13.2004V12.2001H14.0004V10.2001ZM12.2004 11.2001C12.2004 11.7836 12.4322 12.3432 12.8448 12.7557L14.259 11.3415C14.2215 11.304 14.2004 11.2531 14.2004 11.2001H12.2004ZM12.8448 12.7557C13.2573 13.1683 13.8169 13.4001 14.4004 13.4001V11.4001C14.3473 11.4001 14.2965 11.379 14.259 11.3415L12.8448 12.7557ZM15.4004 12.4001V11.6001H13.4004V12.4001H15.4004ZM8.20039 11.2001C8.20039 11.041 8.2636 10.8884 8.37613 10.7758L9.79034 12.19C10.0529 11.9275 10.2004 11.5714 10.2004 11.2001H8.20039ZM8.37613 10.7758C8.48865 10.6633 8.64126 10.6001 8.80039 10.6001V12.6001C9.17169 12.6001 9.52779 12.4526 9.79034 12.19L8.37613 10.7758ZM7.80039 11.6001V12.4001H9.80039V11.6001H7.80039ZM8.80039 13.4001C9.38387 13.4001 9.94345 13.1683 10.356 12.7557L8.94181 11.3415C8.90431 11.379 8.85343 11.4001 8.80039 11.4001V13.4001ZM10.356 12.7557C10.7686 12.3432 11.0004 11.7836 11.0004 11.2001H9.00039C9.00039 11.2531 8.97932 11.304 8.94181 11.3415L10.356 12.7557ZM10.0004 10.2001H9.20039V12.2001H10.0004V10.2001ZM8.80039 15.0001C8.64126 15.0001 8.48865 14.9369 8.37613 14.8244L9.79034 13.4101C9.52779 13.1476 9.17169 13.0001 8.80039 13.0001V15.0001ZM8.37613 14.8244C8.2636 14.7118 8.20039 14.5592 8.20039 14.4001H10.2004C10.2004 14.0288 10.0529 13.6727 9.79034 13.4101L8.37613 14.8244ZM9.20039 15.4001H10.0004V13.4001H9.20039V15.4001ZM11.0004 14.4001C11.0004 13.8166 10.7686 13.257 10.356 12.8445L8.94181 14.2587C8.97932 14.2962 9.00039 14.3471 9.00039 14.4001H11.0004ZM10.356 12.8445C9.94345 12.4319 9.38387 12.2001 8.80039 12.2001V14.2001C8.85343 14.2001 8.9043 14.2212 8.94181 14.2587L10.356 12.8445ZM7.80039 13.2001V14.0001H9.80039V13.2001H7.80039ZM11.6004 10.6001C11.0169 10.6001 10.4573 10.8319 10.0448 11.2445L11.459 12.6587C11.4965 12.6212 11.5473 12.6001 11.6004 12.6001V10.6001ZM10.0448 11.2445C9.63218 11.657 9.40039 12.2166 9.40039 12.8001H11.4004C11.4004 12.7471 11.4215 12.6962 11.459 12.6587L10.0448 11.2445ZM9.40039 12.8001C9.40039 13.3836 9.63218 13.9432 10.0448 14.3557L11.459 12.9415C11.4215 12.904 11.4004 12.8531 11.4004 12.8001H9.40039ZM10.0448 14.3557C10.4573 14.7683 11.0169 15.0001 11.6004 15.0001V13.0001C11.5473 13.0001 11.4965 12.979 11.459 12.9415L10.0448 14.3557ZM11.6004 15.0001C12.1839 15.0001 12.7434 14.7683 13.156 14.3557L11.7418 12.9415C11.7043 12.979 11.6534 13.0001 11.6004 13.0001V15.0001ZM13.156 14.3557C13.5686 13.9432 13.8004 13.3836 13.8004 12.8001H11.8004C11.8004 12.8531 11.7793 12.904 11.7418 12.9415L13.156 14.3557ZM13.8004 12.8001C13.8004 12.2166 13.5686 11.657 13.156 11.2445L11.7418 12.6587C11.7793 12.6962 11.8004 12.7471 11.8004 12.8001H13.8004ZM13.156 11.2445C12.7434 10.8319 12.1839 10.6001 11.6004 10.6001V12.6001C11.6534 12.6001 11.7043 12.6212 11.7418 12.6587L13.156 11.2445Z"
          fill="white"
          mask="url(#path-1-inside-1_1599_2189)"
        />
      </svg>
    ),
    link: "referrals",
  },
  {
    id: 6,
    title: "Withdrawal",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M11.2986 6.63325L9.99855 5.33325V9.72459C9.99855 10.3179 9.28055 10.6159 8.86055 10.1959L7.99722 9.33325C7.66388 8.99992 6.86322 8.79992 6.32922 9.33325C5.79588 9.86659 5.99588 10.6666 6.32922 10.9999L8.73122 13.9333C8.9189 14.1626 9.1552 14.3473 9.42304 14.4742C9.69087 14.601 9.98354 14.6667 10.2799 14.6666H11.9999C12.1767 14.6666 12.3463 14.5963 12.4713 14.4713C12.5963 14.3463 12.6666 14.1767 12.6666 13.9999V9.93325C12.6664 9.32031 12.5455 8.71339 12.3108 8.14717C12.0761 7.58095 11.7321 7.06652 11.2986 6.63325Z"
          fill="#161616"
          fill-opacity="0.6"
        />
        <path
          d="M7.33301 1.33325H8.66634C9.01996 1.33325 9.3591 1.47373 9.60915 1.72378C9.8592 1.97382 9.99967 2.31296 9.99967 2.66659V3.99992M7.33301 1.33325C7.33301 2.22192 7.86634 3.99992 9.99967 3.99992L7.33301 1.33325ZM7.33301 1.33325H5.99967H7.33301ZM9.99967 3.99992V7.99992V3.99992ZM3.33301 7.99992V9.33325C3.33301 9.68687 3.47348 10.026 3.72353 10.2761C3.97358 10.5261 4.31272 10.6666 4.66634 10.6666H5.99967C5.99967 9.77792 5.46634 7.99992 3.33301 7.99992ZM3.33301 7.99992V3.99992V7.99992ZM5.99967 1.33325H4.66634C4.31272 1.33325 3.97358 1.47373 3.72353 1.72378C3.47348 1.97382 3.33301 2.31296 3.33301 2.66659V3.99992M5.99967 1.33325C5.99967 2.22192 5.46634 3.99992 3.33301 3.99992L5.99967 1.33325Z"
          fill="#161616"
          fill-opacity="0.6"
        />
        <path
          d="M5.99967 5.99992C5.99967 6.36811 6.29815 6.66659 6.66634 6.66659C7.03453 6.66659 7.33301 6.36811 7.33301 5.99992C7.33301 5.63173 7.03453 5.33325 6.66634 5.33325C6.29815 5.33325 5.99967 5.63173 5.99967 5.99992Z"
          fill="#161616"
          fill-opacity="0.6"
        />
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M11.2986 6.6335L9.99855 5.3335V9.72483C9.99855 10.3182 9.28055 10.6162 8.86055 10.1962L7.99722 9.3335C7.66388 9.00016 6.86322 8.80016 6.32922 9.3335C5.79588 9.86683 5.99588 10.6668 6.32922 11.0002L8.73122 13.9335C8.9189 14.1628 9.1552 14.3476 9.42304 14.4744C9.69087 14.6012 9.98354 14.667 10.2799 14.6668H11.9999C12.1767 14.6668 12.3463 14.5966 12.4713 14.4716C12.5963 14.3465 12.6666 14.177 12.6666 14.0002V9.9335C12.6664 9.32055 12.5455 8.71364 12.3108 8.14742C12.0761 7.58119 11.7321 7.06676 11.2986 6.6335Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.33398 1.3335H8.66732C9.02094 1.3335 9.36008 1.47397 9.61013 1.72402C9.86018 1.97407 10.0007 2.31321 10.0007 2.66683V4.00016M7.33398 1.3335C7.33398 2.22216 7.86732 4.00016 10.0007 4.00016M7.33398 1.3335H6.00065M10.0007 4.00016V8.00016M6.00065 1.3335H4.66732C4.3137 1.3335 3.97456 1.47397 3.72451 1.72402C3.47446 1.97407 3.33398 2.31321 3.33398 2.66683V4.00016M6.00065 1.3335C6.00065 2.22216 5.46732 4.00016 3.33398 4.00016M3.33398 8.00016V9.3335C3.33398 9.68712 3.47446 10.0263 3.72451 10.2763C3.97456 10.5264 4.3137 10.6668 4.66732 10.6668H6.00065C6.00065 9.77816 5.46732 8.00016 3.33398 8.00016ZM3.33398 8.00016V4.00016"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.00065 6.00016C6.00065 6.36835 6.29913 6.66683 6.66732 6.66683C7.03551 6.66683 7.33398 6.36835 7.33398 6.00016C7.33398 5.63197 7.03551 5.3335 6.66732 5.3335C6.29913 5.3335 6.00065 5.63197 6.00065 6.00016Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    link: "withdrawal",
  },
  {
    id: 7,
    title: "Admin Log",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clip-path="url(#clip0_1599_3565)">
          <path d="M4 9H8V11H4V9Z" fill="#161616" fill-opacity="0.6" />
          <path
            d="M16 2H15V0H5V2H3V3.25L2.4 4H1V5.75L0 7V16H12L16 11V2ZM2 5H10V7H2V5ZM11 15H1V8H11V15ZM12 7H11V4H4V3H12V7ZM14 4.5L13 5.75V2H6V1H14V4.5Z"
            fill="#161616"
            fill-opacity="0.6"
          />
        </g>
        <defs>
          <clipPath id="clip0_1599_3565">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M11.2986 6.6335L9.99855 5.3335V9.72483C9.99855 10.3182 9.28055 10.6162 8.86055 10.1962L7.99722 9.3335C7.66388 9.00016 6.86322 8.80016 6.32922 9.3335C5.79588 9.86683 5.99588 10.6668 6.32922 11.0002L8.73122 13.9335C8.9189 14.1628 9.1552 14.3476 9.42304 14.4744C9.69087 14.6012 9.98354 14.667 10.2799 14.6668H11.9999C12.1767 14.6668 12.3463 14.5966 12.4713 14.4716C12.5963 14.3465 12.6666 14.177 12.6666 14.0002V9.9335C12.6664 9.32055 12.5455 8.71364 12.3108 8.14742C12.0761 7.58119 11.7321 7.06676 11.2986 6.6335Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.33398 1.3335H8.66732C9.02094 1.3335 9.36008 1.47397 9.61013 1.72402C9.86018 1.97407 10.0007 2.31321 10.0007 2.66683V4.00016M7.33398 1.3335C7.33398 2.22216 7.86732 4.00016 10.0007 4.00016M7.33398 1.3335H6.00065M10.0007 4.00016V8.00016M6.00065 1.3335H4.66732C4.3137 1.3335 3.97456 1.47397 3.72451 1.72402C3.47446 1.97407 3.33398 2.31321 3.33398 2.66683V4.00016M6.00065 1.3335C6.00065 2.22216 5.46732 4.00016 3.33398 4.00016M3.33398 8.00016V9.3335C3.33398 9.68712 3.47446 10.0263 3.72451 10.2763C3.97456 10.5264 4.3137 10.6668 4.66732 10.6668H6.00065C6.00065 9.77816 5.46732 8.00016 3.33398 8.00016ZM3.33398 8.00016V4.00016"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.00065 6.00016C6.00065 6.36835 6.29913 6.66683 6.66732 6.66683C7.03551 6.66683 7.33398 6.36835 7.33398 6.00016C7.33398 5.63197 7.03551 5.3335 6.66732 5.3335C6.29913 5.3335 6.00065 5.63197 6.00065 6.00016Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    link: "activity",
  },
  {
    id: 8,
    title: "Browsing Users",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 20 20"
        className="opacity-90"
      >
        <path
          fill="currentColor"
          d="M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5V6H3.003v1H15a3.5 3.5 0 0 0-2.45 6c-.816 0-1.461.412-1.864.864A2.68 2.68 0 0 0 10 15.62v.32q.002.559.16 1.06H5.5A2.5 2.5 0 0 1 3 14.5zM15 13a2.5 2.5 0 1 1 2-4h-2v1h2.45a2.5 2.5 0 0 1 0 1H15v1h2c-.456.607-1.182 1-2 1m-2.45 1c-.465 0-.855.235-1.116.529c-.26.291-.434.686-.434 1.091v.32c0 1.634 1.633 3.06 4 3.06c1.24 0 2.28-.392 2.988-1H15v-1h3.761a2.5 2.5 0 0 0 .238-1H15v-1h3.867a1.8 1.8 0 0 0-.3-.471c-.262-.294-.652-.529-1.117-.529z"
        />
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 20 20"
      >
        <path
          fill="#ffffff"
          d="M5.497 3a2.5 2.5 0 0 0-2.5 2.5v9a2.5 2.5 0 0 0 2.5 2.5h4.664a3.5 3.5 0 0 1-.16-1H5.497a1.5 1.5 0 0 1-1.5-1.5V7H17V6h-.003v-.5a2.5 2.5 0 0 0-2.5-2.5zm10.5 2.5V6h-12v-.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5M15 12a1.5 1.5 0 0 1 0-3h2a2.5 2.5 0 1 0 0 3zm-2.45 3c-.115 0-.25.06-.369.193a.68.68 0 0 0-.181.427v.32c0 .889.97 2.06 3 2.06h2.988c-.708.608-1.747 1-2.988 1c-2.367 0-4-1.426-4-3.06v-.32c0-.405.175-.8.434-1.091c.261-.294.651-.529 1.116-.529h4.9c.465 0 .855.235 1.116.529c.122.137.226.298.3.471zm4.95-4.5q0 .257-.05.5H15v-1h2.45q.05.243.05.5M15 17h3.761a2.5 2.5 0 0 0 .238-1H15z"
        />
      </svg>
    ),
    link: "browsing-users",
  },
  {
    id: 9,
    title: "Ideas",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 256 256"
      >
        <path
          fill="#666666"
          d="M143.38 17.85a8 8 0 0 0-12.63 3.41l-22 60.41l-24.16-23.41a8 8 0 0 0-11.93.89C51 87.53 40 116.08 40 144a88 88 0 0 0 176 0c0-59.45-50.79-108-72.62-126.15"
        />
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 256 256"
      >
        <path
          fill="#ffffff"
          d="M145.93 14.77A12 12 0 0 0 127 19.89L107.07 74.5L87.38 55.39a12 12 0 0 0-17.9 1.33C47.27 85.82 36 115.19 36 144a92 92 0 0 0 184 0c0-61.15-51.8-110.75-74.07-129.23M128 212a68.07 68.07 0 0 1-68-68c0-19.94 7-40.62 20.71-61.64l22.93 22.25a12 12 0 0 0 19.63-4.5l20.21-55.4C165.39 65.61 196 102.29 196 144a68.07 68.07 0 0 1-68 68"
        />
      </svg>
    ),
    link: "ideas",
  },
  {
    id: 10,
    title: "Chatbot",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
      >
        <path
          fill="#666666"
          d="M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-4.724l-4.762 2.857a1 1 0 0 1-1.508-.743L7 21v-2H6a4 4 0 0 1-3.995-3.8L2 15V7a4 4 0 0 1 4-4zm-2.8 9.286a1 1 0 0 0-1.414.014a2.5 2.5 0 0 1-3.572 0a1 1 0 0 0-1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0-.014-1.414M9.51 8H9.5a1 1 0 1 0 0 2h.01a1 1 0 0 0 0-2m5 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2"
        />
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
      >
        <path
          fill="#ffffff"
          d="M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-4.724l-4.762 2.857a1 1 0 0 1-1.508-.743L7 21v-2H6a4 4 0 0 1-3.995-3.8L2 15V7a4 4 0 0 1 4-4zm-2.8 9.286a1 1 0 0 0-1.414.014a2.5 2.5 0 0 1-3.572 0a1 1 0 0 0-1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0-.014-1.414M9.51 8H9.5a1 1 0 1 0 0 2h.01a1 1 0 0 0 0-2m5 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2"
        />
      </svg>
    ),
    link: "chatbot",
  },
  {
    id: 4,
    title: "AI Subs",
    iconNormal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M4.759 4.5C3.534 4.5 2.5 5.55 2.5 6.896v.18c0 1.489.977 2.578 2.259 2.578h2.05a.5.5 0 1 1 0 1H4.76c-1.956 0-3.259-1.666-3.259-3.577v-.181C1.5 5.044 2.936 3.5 4.759 3.5h1.046C7.408 3.5 8.5 4.751 8.5 6.051v1.65c0 .758-.59 1.414-1.37 1.414a1.34 1.34 0 0 1-1.024-.473a1.7 1.7 0 0 1-1.175.473c-1.076 0-1.828-.984-1.828-2.038s.752-2.039 1.828-2.039c.333 0 .635.094.893.255a.5.5 0 0 1 .936.245v2.164c0 .251.188.413.37.413s.37-.162.37-.413v-1.65C7.5 5.3 6.852 4.5 5.805 4.5zm1 2.577c0-.645-.437-1.039-.828-1.039s-.828.394-.828 1.039s.437 1.038.828 1.038s.829-.393.829-1.038m-1 7.27c-1.225 0-2.259 1.049-2.259 2.395v.181c0 1.488.977 2.577 2.259 2.577h2.05a.5.5 0 0 1 0 1H4.76c-1.956 0-3.259-1.666-3.259-3.577v-.18c0-1.853 1.436-3.397 3.259-3.397h1.046c1.603 0 2.695 1.252 2.695 2.551v1.651c0 .758-.59 1.414-1.37 1.414a1.34 1.34 0 0 1-1.024-.474a1.7 1.7 0 0 1-1.175.474c-1.076 0-1.828-.985-1.828-2.039s.752-2.038 1.828-2.038c.333 0 .635.094.893.255a.5.5 0 0 1 .936.245v2.163c0 .252.188.414.37.414s.37-.163.37-.414v-1.65c0-.752-.648-1.552-1.695-1.552zm1 2.576c0-.645-.437-1.038-.828-1.038s-.828.393-.828 1.038s.437 1.039.828 1.039s.829-.394.829-1.039M10 5.5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1m0 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m0 7a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1m0 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
          clip-rule="evenodd"
        />
      </svg>
    ),
    iconSelected: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
      >
        <path
          fill="#ffffff"
          fill-rule="evenodd"
          d="M4.759 4.5C3.534 4.5 2.5 5.55 2.5 6.896v.18c0 1.489.977 2.578 2.259 2.578h2.05a.5.5 0 1 1 0 1H4.76c-1.956 0-3.259-1.666-3.259-3.577v-.181C1.5 5.044 2.936 3.5 4.759 3.5h1.046C7.408 3.5 8.5 4.751 8.5 6.051v1.65c0 .758-.59 1.414-1.37 1.414a1.34 1.34 0 0 1-1.024-.473a1.7 1.7 0 0 1-1.175.473c-1.076 0-1.828-.984-1.828-2.038s.752-2.039 1.828-2.039c.333 0 .635.094.893.255a.5.5 0 0 1 .936.245v2.164c0 .251.188.413.37.413s.37-.162.37-.413v-1.65C7.5 5.3 6.852 4.5 5.805 4.5zm1 2.577c0-.645-.437-1.039-.828-1.039s-.828.394-.828 1.039s.437 1.038.828 1.038s.829-.393.829-1.038m-1 7.27c-1.225 0-2.259 1.049-2.259 2.395v.181c0 1.488.977 2.577 2.259 2.577h2.05a.5.5 0 0 1 0 1H4.76c-1.956 0-3.259-1.666-3.259-3.577v-.18c0-1.853 1.436-3.397 3.259-3.397h1.046c1.603 0 2.695 1.252 2.695 2.551v1.651c0 .758-.59 1.414-1.37 1.414a1.34 1.34 0 0 1-1.024-.474a1.7 1.7 0 0 1-1.175.474c-1.076 0-1.828-.985-1.828-2.039s.752-2.038 1.828-2.038c.333 0 .635.094.893.255a.5.5 0 0 1 .936.245v2.163c0 .252.188.414.37.414s.37-.163.37-.414v-1.65c0-.752-.648-1.552-1.695-1.552zm1 2.576c0-.645-.437-1.038-.828-1.038s-.828.393-.828 1.038s.437 1.039.828 1.039s.829-.394.829-1.039M10 5.5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1m0 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m0 7a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1m0 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
          clip-rule="evenodd"
        />
      </svg>
    ),
    link: "ai-sub-receipts",
  },
  // {
  //     id: 8,
  //     title: "Logout",
  //     iconNormal: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  //         <path d="M13.5628 11.4375H12.4644C12.3894 11.4375 12.3191 11.4703 12.2722 11.5281C12.1628 11.661 12.0457 11.7891 11.9222 11.911C11.4174 12.4163 10.8194 12.8191 10.1613 13.0969C9.4795 13.3849 8.7467 13.5326 8.0066 13.5313C7.25816 13.5313 6.53316 13.3844 5.85191 13.0969C5.19383 12.8191 4.59583 12.4163 4.09097 11.911C3.58522 11.4073 3.18194 10.8104 2.90347 10.1531C2.61441 9.4719 2.4691 8.74846 2.4691 8.00002C2.4691 7.25159 2.61597 6.52815 2.90347 5.8469C3.1816 5.18909 3.5816 4.5969 4.09097 4.08909C4.60035 3.58127 5.19254 3.18127 5.85191 2.90315C6.53316 2.61565 7.25816 2.46877 8.0066 2.46877C8.75504 2.46877 9.48003 2.61409 10.1613 2.90315C10.8207 3.18127 11.4128 3.58127 11.9222 4.08909C12.0457 4.21252 12.1613 4.34065 12.2722 4.4719C12.3191 4.52971 12.391 4.56252 12.4644 4.56252H13.5628C13.6613 4.56252 13.7222 4.45315 13.6675 4.37034C12.4691 2.50784 10.3722 1.27502 7.98941 1.28127C4.24566 1.29065 1.2441 4.32971 1.2816 8.06877C1.3191 11.7485 4.31597 14.7188 8.0066 14.7188C10.3832 14.7188 12.4707 13.4875 13.6675 11.6297C13.7207 11.5469 13.6613 11.4375 13.5628 11.4375ZM14.9519 7.90159L12.7347 6.15159C12.6519 6.08596 12.5316 6.14534 12.5316 6.25002V7.43752H7.62535C7.5566 7.43752 7.50035 7.49377 7.50035 7.56252V8.43752C7.50035 8.50627 7.5566 8.56252 7.62535 8.56252H12.5316V9.75002C12.5316 9.85471 12.6535 9.91409 12.7347 9.84846L14.9519 8.09846C14.9669 8.08677 14.9789 8.07183 14.9872 8.05477C14.9956 8.03772 14.9999 8.019 14.9999 8.00002C14.9999 7.98105 14.9956 7.96233 14.9872 7.94527C14.9789 7.92822 14.9669 7.91328 14.9519 7.90159Z" fill="#B20F19" />
  //     </svg>,
  //     iconSelected: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  //         <path d="M11.2986 6.6335L9.99855 5.3335V9.72483C9.99855 10.3182 9.28055 10.6162 8.86055 10.1962L7.99722 9.3335C7.66388 9.00016 6.86322 8.80016 6.32922 9.3335C5.79588 9.86683 5.99588 10.6668 6.32922 11.0002L8.73122 13.9335C8.9189 14.1628 9.1552 14.3476 9.42304 14.4744C9.69087 14.6012 9.98354 14.667 10.2799 14.6668H11.9999C12.1767 14.6668 12.3463 14.5966 12.4713 14.4716C12.5963 14.3465 12.6666 14.177 12.6666 14.0002V9.9335C12.6664 9.32055 12.5455 8.71364 12.3108 8.14742C12.0761 7.58119 11.7321 7.06676 11.2986 6.6335Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
  //         <path d="M7.33398 1.3335H8.66732C9.02094 1.3335 9.36008 1.47397 9.61013 1.72402C9.86018 1.97407 10.0007 2.31321 10.0007 2.66683V4.00016M7.33398 1.3335C7.33398 2.22216 7.86732 4.00016 10.0007 4.00016M7.33398 1.3335H6.00065M10.0007 4.00016V8.00016M6.00065 1.3335H4.66732C4.3137 1.3335 3.97456 1.47397 3.72451 1.72402C3.47446 1.97407 3.33398 2.31321 3.33398 2.66683V4.00016M6.00065 1.3335C6.00065 2.22216 5.46732 4.00016 3.33398 4.00016M3.33398 8.00016V9.3335C3.33398 9.68712 3.47446 10.0263 3.72451 10.2763C3.97456 10.5264 4.3137 10.6668 4.66732 10.6668H6.00065C6.00065 9.77816 5.46732 8.00016 3.33398 8.00016ZM3.33398 8.00016V4.00016" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
  //         <path d="M6.00065 6.00016C6.00065 6.36835 6.29913 6.66683 6.66732 6.66683C7.03551 6.66683 7.33398 6.36835 7.33398 6.00016C7.33398 5.63197 7.03551 5.3335 6.66732 5.3335C6.29913 5.3335 6.00065 5.63197 6.00065 6.00016Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
  //     </svg>
  // },
];

const logout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("is_analyst");
  localStorage.removeItem("is_staff");
  window.location.href = "/";
};

function SideMenu({ route }) {
  const isAnalyst = localStorage.getItem("is_analyst");

  const analystMenuItems = [
    {
      id: 9,
      title: "Ideas",
      iconNormal: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 256 256"
        >
          <path
            fill="#666666"
            d="M143.38 17.85a8 8 0 0 0-12.63 3.41l-22 60.41l-24.16-23.41a8 8 0 0 0-11.93.89C51 87.53 40 116.08 40 144a88 88 0 0 0 176 0c0-59.45-50.79-108-72.62-126.15"
          />
        </svg>
      ),
      iconSelected: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 256 256"
        >
          <path
            fill="#ffffff"
            d="M145.93 14.77A12 12 0 0 0 127 19.89L107.07 74.5L87.38 55.39a12 12 0 0 0-17.9 1.33C47.27 85.82 36 115.19 36 144a92 92 0 0 0 184 0c0-61.15-51.8-110.75-74.07-129.23M128 212a68.07 68.07 0 0 1-68-68c0-19.94 7-40.62 20.71-61.64l22.93 22.25a12 12 0 0 0 19.63-4.5l20.21-55.4C165.39 65.61 196 102.29 196 144a68.07 68.07 0 0 1-68 68"
          />
        </svg>
      ),
      link: "ideas",
    },
    {
      id: 9,
      title: "Chatbot",
      iconNormal: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        >
          <path
            fill="#666666"
            d="M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-4.724l-4.762 2.857a1 1 0 0 1-1.508-.743L7 21v-2H6a4 4 0 0 1-3.995-3.8L2 15V7a4 4 0 0 1 4-4zm-2.8 9.286a1 1 0 0 0-1.414.014a2.5 2.5 0 0 1-3.572 0a1 1 0 0 0-1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0-.014-1.414M9.51 8H9.5a1 1 0 1 0 0 2h.01a1 1 0 0 0 0-2m5 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2"
          />
        </svg>
      ),
      iconSelected: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        >
          <path
            fill="#ffffff"
            d="M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-4.724l-4.762 2.857a1 1 0 0 1-1.508-.743L7 21v-2H6a4 4 0 0 1-3.995-3.8L2 15V7a4 4 0 0 1 4-4zm-2.8 9.286a1 1 0 0 0-1.414.014a2.5 2.5 0 0 1-3.572 0a1 1 0 0 0-1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0-.014-1.414M9.51 8H9.5a1 1 0 1 0 0 2h.01a1 1 0 0 0 0-2m5 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2"
          />
        </svg>
      ),
      link: "chatbot",
    },
  ];

  return (
    <div className="lg:w-[10%] bg-white hidden lg:block">
      <div className="flex justify-between mt-[1rem] mb-[2rem] px-[1rem]">
        <div className="w-[5.375rem] h-[1.75rem] bg-black"></div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4 17.7143V6.28571C4 5.67951 4.24082 5.09812 4.66947 4.66947C5.09812 4.24082 5.67951 4 6.28571 4L17.7143 4C18.3205 4 18.9019 4.24082 19.3305 4.66947C19.7592 5.09812 20 5.67951 20 6.28571V17.7143C20 18.3205 19.7592 18.9019 19.3305 19.3305C18.9019 19.7592 18.3205 20 17.7143 20H6.28571C5.67951 20 5.09812 19.7592 4.66947 19.3305C4.24082 18.9019 4 18.3205 4 17.7143Z"
            stroke="#161616"
            stroke-opacity="0.6"
            stroke-width="1.14286"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.28571 17.7143V6.28571C6.28571 5.67951 6.52653 5.09812 6.95518 4.66947C7.38384 4.24082 7.96522 4 8.57143 4H6.28571C5.14286 4 4 5.02286 4 6.28571V17.7143C4 18.9771 5.14286 20 6.28571 20H8.57143C7.96522 20 7.38384 19.7592 6.95518 19.3305C6.52653 18.9019 6.28571 18.3205 6.28571 17.7143Z"
            fill="#161616"
            fill-opacity="0.6"
            stroke="#161616"
            stroke-opacity="0.6"
            stroke-width="1.14286"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.0008 15.4284L8.57227 11.9999M8.57227 11.9999L12.0008 8.57129M8.57227 11.9999H17.7151"
            stroke="#161616"
            stroke-opacity="0.6"
            stroke-width="1.14286"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div className="flex flex-col gap-[2rem] border-b-[0.0625rem] border-b-[#D8D8D8] pb-[2rem]">
        {isAnalyst === "true"
          ? analystMenuItems.map((item) => (
              <Link
                key={item.id}
                to={`/${item.link}`}
                className={`${
                  item.link === route && "bg-[#0FB23C]"
                } flex items-center gap-[0.5rem] pl-[1rem] py-[0.25rem]`}
              >
                {item.link === route ? item.iconSelected : item.iconNormal}
                <p
                  className={`${
                    item.link === route ? "text-white" : "text-[#16161699]"
                  } whitespace-nowrap font-poppins text-[0.75rem]`}
                >
                  {item.title}
                </p>
              </Link>
            ))
          : menuItems.map((item) => (
              <Link
                key={item.id}
                to={`/${item.link}`}
                className={`${
                  item.link === route && "bg-[#0FB23C]"
                } flex items-center gap-[0.5rem] pl-[1rem] py-[0.25rem]`}
              >
                {item.link === route ? item.iconSelected : item.iconNormal}
                <p
                  className={`${
                    item.link === route ? "text-white" : "text-[#16161699]"
                  } whitespace-nowrap font-poppins text-[0.75rem]`}
                >
                  {item.title}
                </p>
              </Link>
            ))}
      </div>
      <div
        onClick={() => logout()}
        className="flex cursor-pointer items-center mt-[2.5rem] px-[1.5rem] gap-[0.5rem]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M13.5628 11.4375H12.4644C12.3894 11.4375 12.3191 11.4703 12.2722 11.5281C12.1628 11.661 12.0457 11.7891 11.9222 11.911C11.4174 12.4163 10.8194 12.8191 10.1613 13.0969C9.4795 13.3849 8.7467 13.5326 8.0066 13.5313C7.25816 13.5313 6.53316 13.3844 5.85191 13.0969C5.19383 12.8191 4.59583 12.4163 4.09097 11.911C3.58522 11.4073 3.18194 10.8104 2.90347 10.1531C2.61441 9.4719 2.4691 8.74846 2.4691 8.00002C2.4691 7.25159 2.61597 6.52815 2.90347 5.8469C3.1816 5.18909 3.5816 4.5969 4.09097 4.08909C4.60035 3.58127 5.19254 3.18127 5.85191 2.90315C6.53316 2.61565 7.25816 2.46877 8.0066 2.46877C8.75504 2.46877 9.48003 2.61409 10.1613 2.90315C10.8207 3.18127 11.4128 3.58127 11.9222 4.08909C12.0457 4.21252 12.1613 4.34065 12.2722 4.4719C12.3191 4.52971 12.391 4.56252 12.4644 4.56252H13.5628C13.6613 4.56252 13.7222 4.45315 13.6675 4.37034C12.4691 2.50784 10.3722 1.27502 7.98941 1.28127C4.24566 1.29065 1.2441 4.32971 1.2816 8.06877C1.3191 11.7485 4.31597 14.7188 8.0066 14.7188C10.3832 14.7188 12.4707 13.4875 13.6675 11.6297C13.7207 11.5469 13.6613 11.4375 13.5628 11.4375ZM14.9519 7.90159L12.7347 6.15159C12.6519 6.08596 12.5316 6.14534 12.5316 6.25002V7.43752H7.62535C7.5566 7.43752 7.50035 7.49377 7.50035 7.56252V8.43752C7.50035 8.50627 7.5566 8.56252 7.62535 8.56252H12.5316V9.75002C12.5316 9.85471 12.6535 9.91409 12.7347 9.84846L14.9519 8.09846C14.9669 8.08677 14.9789 8.07183 14.9872 8.05477C14.9956 8.03772 14.9999 8.019 14.9999 8.00002C14.9999 7.98105 14.9956 7.96233 14.9872 7.94527C14.9789 7.92822 14.9669 7.91328 14.9519 7.90159Z"
            fill="#B20F19"
          />
        </svg>
        <p className="font-poppins text-[0.875rem] text-[#B20F19]">Logout</p>
      </div>
    </div>
  );
}

export default SideMenu;
